import { Component } from '@angular/core';

@Component({
  selector: 'wp-section',
  standalone: true,
  templateUrl: './section.component.html',
  styleUrl: './section.component.scss',
})
export class SectionComponent {}
